/* global window:true */

import React from 'react';
import PropTypes from 'prop-types';

class FavouriteUpdateListener extends React.Component {
  componentDidMount() {
    const { showPlanningEnabled } = this.props;
    if (showPlanningEnabled) {
      if (window && window.showPlanningReduxDispatcher) {
        window.showPlanningReduxDispatcher.subscribe(() => {
          const currentState = window.showPlanningReduxDispatcher.getState();
          const updatedExhibitorList = currentState.exhibitorReducer;
          const updatedProductList = currentState.productReducer;
          if (updatedExhibitorList.newExhibitor || updatedExhibitorList.oldExhibitor) {
            this.changeShowPlan(updatedExhibitorList);
          }
          if (updatedProductList.newProductId || updatedProductList.oldProductId) {
            this.changeShowPlan(updatedProductList);
          }
        });
      }
    }
  }

  addExhibitorToShowPlan = (exhibitorId) => {
    if (!this.props.showPlan || !this.props.showPlan.exhibitorIds) return;
    if (this.props.showPlan.exhibitorIds.indexOf(exhibitorId) === -1) {
      this.props.showPlan.exhibitorIds.push(exhibitorId);
      this.props.favouriteCallback(this.props.showPlan);
    }
  };

  removeExhibitorFromShowPlan = (exhibitorId) => {
    if (!this.props.showPlan || !this.props.showPlan.exhibitorIds) return;
    const index = this.props.showPlan.exhibitorIds.indexOf(exhibitorId);
    if (index !== -1) {
      this.props.showPlan.exhibitorIds.splice(index, 1);
      this.props.unfavouriteCallback(this.props.showPlan);
    }
  };

  addProductToShowPlan = (productId) => {
    if (!this.props.showPlan || !this.props.showPlan.productIds) return;
    if (this.props.showPlan.productIds.indexOf(productId) === -1) {
      this.props.showPlan.productIds.push(productId);
      this.props.favouriteCallback(this.props.showPlan);
    }
  };

  removeProductFromShowPlan = (productId) => {
    if (!this.props.showPlan || !this.props.showPlan.productIds) return;
    const index = this.props.showPlan.productIds.indexOf(productId);
    if (index !== -1) {
      this.props.showPlan.productIds.splice(index, 1);
      this.props.unfavouriteCallback(this.props.showPlan);
    }
  };

  changeShowPlan = (data) => {
    if (data.newExhibitor) {
      this.addExhibitorToShowPlan(data.newExhibitor.exhibitorId);
    } else if (data.oldExhibitor) {
      this.removeExhibitorFromShowPlan(data.oldExhibitor.exhibitorId);
    } else if (data.newProductId) {
      this.addProductToShowPlan(data.newProductId);
    } else if (data.oldProductId) {
      this.removeProductFromShowPlan(data.oldProductId);
    }
  };
  render() {
    return null;
  }
}

FavouriteUpdateListener.propTypes = {
  showPlanningEnabled: PropTypes.bool,
  showPlan: PropTypes.shape({
    exhibitorIds: PropTypes.arrayOf(PropTypes.string),
    productIds: PropTypes.arrayOf(PropTypes.string)
  }),
  favouriteCallback: PropTypes.func,
  unfavouriteCallback: PropTypes.func
};

export default FavouriteUpdateListener;
